import React, { useRef, useState } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
export const AcPopover = (props) => {
    const { text, placement = 'top', type, linger, dark, textCenter, className, children } = props;
    const [show, setShow] = useState();
    const [target, setTarget] = useState(null);
    const [timerId, setTimerId] = useState();
    const ref = useRef(null);
    const handleEnter = (event) => {
        setTarget(event.target);
        setShow(true);
        clearTimeout(timerId);
    };
    const handleLeave = (event) => {
        if (linger) {
            const timerId = setTimeout(() => {
                setTarget(null);
                setShow(false);
            }, 1500);
            setTimerId(timerId);
        }
        else {
            setTarget(null);
            setShow(false);
        }
    };
    const handleCancel = () => {
        setTarget(null);
        setShow(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className, onMouseEnter: handleEnter, onMouseLeave: handleLeave, onClick: handleCancel },
            React.createElement("span", { ref: ref }),
            children),
        React.createElement(Overlay, { show: show, target: target, container: ref.current, containerPadding: 20, placement: placement },
            React.createElement(Popover, { className: `${dark ? 'popover-dark' : ''} ${type === 'error' ? 'popover-error' : ''} ${textCenter ? 'text-center' : ''}`, id: "acpopover" },
                React.createElement(Popover.Content, null, text)))));
};
AcPopover.displayName = 'AcPopover';
